export default __webpack_public_path__ + "static/media/hotel2.807d5cd5.jpg";